import { useCallback, useState } from 'react';
import dirkUrl from '../assets/dirk.jpg';
import type { Store } from '../data/store';
import { isDemoStore } from '../data/store';
import { CALENDLY_LINK_URL } from '../helpers/calendly';
import { SignupButton } from './buttons';
import { Modal } from './modal';

interface DemoCTAModalProps {
  visible: boolean;
  onClose: () => void;
}

export const DemoCTAModal: React.FC<DemoCTAModalProps> = ({ visible, onClose }) => {
  return (
    <Modal title="Demo Store" visible={visible} onClose={onClose} size="sm">
      <div className="flex flex-col gap-4 py-1">
        <div className="flex items-center gap-3">
          <img
            src={dirkUrl}
            alt="Dirk van Veen, Co-Founder"
            className="w-14 h-14 rounded-full border-2 border-primary-200 shadow-md shrink-0"
          />
          <div>
            <p className="font-semibold text-gray-800">Dirk van Veen</p>
            <p className="text-sm text-gray-500">Co-Founder & Liquor Store Owner</p>
          </div>
        </div>
        <p className="text-sm text-gray-600">
          Ready to get started? I'll personally walk you through your setup and make sure you're
          getting the most out of Orderbot.
        </p>
        <a
          href={CALENDLY_LINK_URL}
          target="_blank"
          rel="noreferrer"
          onClick={() => window.plausible?.('Schedule Demo Click')}
          className="w-full py-2.5 px-4 bg-primary-500 text-white font-semibold rounded-md hover:bg-primary-600 transition duration-150 cursor-pointer text-center"
        >
          Book a Call with Dirk
        </a>
        <SignupButton
          target="_blank"
          rel="noreferrer"
          className="text-sm text-gray-400 hover:text-gray-600 transition duration-150 text-center"
        >
          or sign up directly →
        </SignupButton>
      </div>
    </Modal>
  );
};

export const useDemoCTA = (store?: Store) => {
  const [visible, setVisible] = useState(false);
  const isDemo = isDemoStore(store);

  const showCTA = useCallback(() => setVisible(true), []);
  const hideCTA = useCallback(() => setVisible(false), []);

  return {
    isDemo,
    showCTA,
    ctaProps: {
      visible,
      onClose: hideCTA,
    },
  };
};
